import { fromJS } from "immutable";
import mapValues from "lodash/mapValues";
import compact from "lodash/compact";
import QueryResult from "./QueryResult";
import SearchError from "./SearchError";
import ResultWindowLimitError, { isResultWindowLimitErrorResponse } from "./ResultWindowLimitError";
class SearchResult {
  constructor(result) {
    var _a;
    this._result = fromJS(result);
    this._results = fromJS(mapValues(result.results, (queryResult) => new QueryResult(queryResult)));
    this._errors = fromJS(
      ((_a = result == null ? void 0 : result.errors) != null ? _a : []).map((error) => {
        if (isResultWindowLimitErrorResponse(error)) {
          return new ResultWindowLimitError(error, this);
        }
        return new SearchError(error);
      })
    );
  }
  get result() {
    return this._result.toJS();
  }
  get results() {
    return this._results.toJS();
  }
  get errors() {
    return this._errors.toJS();
  }
  forId(queryId) {
    return this._results.get(queryId);
  }
  withErrors(errors) {
    return new SearchResult({ ...this.result, errors });
  }
  updateSearchTypes(searchTypeResults) {
    const updatedResult = this.result;
    searchTypeResults.forEach((searchTypeResult) => {
      const searchQuery = this._getQueryBySearchTypeId(searchTypeResult.id);
      updatedResult.results[searchQuery.query.id].search_types[searchTypeResult.id] = searchTypeResult;
    });
    return new SearchResult(updatedResult);
  }
  getSearchTypesFromResponse(searchTypeIds) {
    const searchTypes = searchTypeIds.map((searchTypeId) => {
      const relatedQuery = this._getQueryBySearchTypeId(searchTypeId);
      return SearchResult._getSearchTypeFromQuery(relatedQuery, searchTypeId);
    });
    return SearchResult._filterFailedSearchTypes(searchTypes);
  }
  _getQueryBySearchTypeId(searchTypeId) {
    return Object.values(this.result.results).find(
      (query) => SearchResult._getSearchTypeFromQuery(query, searchTypeId)
    );
  }
  static _getSearchTypeFromQuery(query, searchTypeId) {
    return query && query.search_types ? query.search_types[searchTypeId] : void 0;
  }
  static _filterFailedSearchTypes(searchTypes) {
    return compact(searchTypes);
  }
}
export default SearchResult;
